export default __webpack_public_path__ + "static/media/sensor-status.4dc8c0da.svg";